/* @ngInject */
function guestHeaderFiltersService ($translate, Utils, CONSTANTS, ConnectorWebService, BriefingService) {
  const service = {
    getHeaderFilters
  }
  return service

  function _getApprovalsFilters (locale) {
    return [{
      name: 'approvalStatus',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: null,
      props: {
        label: $translate.instant('exhibit'),
        multiple: false,
        switchMode: false,
        udsDisabled: false,
        options: [
          {
            label: $translate.instant('pending'),
            value: 'PENDING',
            icon: 'clock',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('approved'),
            value: 'APPROVED',
            icon: 'success',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('adjustments'),
            value: 'ADJUST',
            icon: 'clock',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('rejected'),
            value: 'REJECTED',
            icon: 'clear',
            active: false,
            disabled: false
          }
        ]
      }
    },
    {
      name: 'taskTypes',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: null,
      props: {
        label: $translate.instant('type'),
        multiple: false,
        switchMode: false,
        udsDisabled: false,
        options: [
          {
            label: $translate.instant('requests'),
            value: 'REQUEST',
            icon: 'workflow',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('tasks'),
            value: 'TASK',
            icon: 'tasks',
            active: false,
            disabled: false
          }
        ]
      }
    },
    {
      name: 'taskStatus',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: [],
      props: {
        label: $translate.instant('status'),
        multiple: true,
        switchMode: false,
        udsDisabled: false,
        options: [
          {
            label: $translate.instant('inboxStatus'),
            value: 'INBOX',
            icon: 'arrow-down',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('adjustments'),
            value: 'WAITING_ADM_ADJUST',
            icon: 'alert-triangle',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('inProgress'),
            value: 'PROGRESS',
            icon: 'arts',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('underReview'),
            value: 'REVIEW',
            icon: 'clock',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('done'),
            value: 'DONE',
            icon: 'check',
            active: false,
            disabled: false
          }
        ]
      }
    },
    {
      name: 'priorities',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: [],
      props: {
        label: $translate.instant('priorityFilter'),
        multiple: true,
        switchMode: false,
        udsDisabled: false,
        options: [
          {
            label: $translate.instant('LOW'),
            value: 'LOW',
            icon: 'chevron-down',
            active: false,
            disabled: false,
            color: 'feedbackColorGreenPure'
          },
          {
            label: $translate.instant('MEDIUM'),
            value: 'MEDIUM',
            icon: 'minus',
            active: false,
            disabled: false,
            color: 'feedbackColorOrangePure'
          },
          {
            label: $translate.instant('HIGH'),
            value: 'HIGH',
            icon: 'chevron-up',
            active: false,
            disabled: false,
            color: 'feedbackColorRedPure'
          },
          {
            label: $translate.instant('URGENT'),
            value: 'URGENT',
            icon: 'chevron-up-double',
            active: false,
            disabled: false,
            color: 'feedbackColorRedPure'
          }
        ]
      }
    },
    {
      name: 'createdAt',
      type: 'DATE_PICKER',
      grouped: true,
      defaultValue: '',
      props: {
        locale,
        label: $translate.instant('creationDate'),
        firstDayOfWeek: '1',
        direction: 'right'
      }
    },
    {
      name: 'approvalDeadline',
      type: 'DATE_PICKER',
      grouped: true,
      defaultValue: '',
      props: {
        locale,
        label: $translate.instant('approvalFormDialog.approvalDeadline'),
        firstDayOfWeek: '1',
        direction: 'right'
      }
    }]
  }

  function _getRequestsFilters (locale) {
    return [{
      name: 'taskStatus',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: [],
      props: {
        label: $translate.instant('status'),
        multiple: true,
        switchMode: false,
        udsDisabled: false,
        options: [
          {
            label: $translate.instant('waitingApproval'),
            value: 'WAITING_RESPONSE',
            icon: 'invite-resend',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('adjustments'),
            value: 'WAITING_ADM_ADJUST',
            icon: 'alert-triangle',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('inProgress'),
            value: 'PROGRESS',
            icon: 'arts',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('underReview'),
            value: 'REVIEW',
            icon: 'clock',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('done'),
            value: 'DONE',
            icon: 'check',
            active: false,
            disabled: false
          }
        ]
      }
    },
    {
      name: 'form',
      type: 'INPUT_MULTISELECT',
      grouped: false,
      defaultValue: [],
      props: {
        label: $translate.instant('briefings'),
        placeholder: $translate.instant('selectPlaceholder'),
        emptyMsg: $translate.instant('noResults'),
        type: 'text',
        hasMoreOptions: false,
        udsDisabled: false,
        options: []
      },
      loadData: (search, top, skip) => BriefingService.getCompanyBriefings('WORKFLOW', null, search, top, skip)
    },
    {
      name: 'createdAt',
      type: 'DATE_PICKER',
      grouped: false,
      defaultValue: '',
      props: {
        locale,
        label: $translate.instant('creationDate'),
        firstDayOfWeek: '1',
        direction: 'right'
      }
    }]
  }

  function getHeaderFilters (type, locale) {
    return type === 'requests' ? _getRequestsFilters(locale) : _getApprovalsFilters(locale)
  }
}

export { guestHeaderFiltersService }
